import React, { useState } from 'react';
import { Box, Button, FormControl, FormLabel, Input, VStack, Text } from "@chakra-ui/react";
import { supabase } from "./supabaseClient";
import { useNavigate, useLocation } from 'react-router-dom';

export default function ResetPassword() {
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error: verifyError } = await supabase.auth.verifyOtp({
      email,
      token: resetCode,
      type: 'recovery'
    });

    if (verifyError) {
      setMessage('Kod geçersiz veya süresi dolmuş. Tekrar deneyin.');
      setLoading(false);
      return;
    }

    const { error: updateError } = await supabase.auth.updateUser({
      password: newPassword
    });

    if (updateError) {
      setMessage('Şifre güncellenirken hata oluştu. Tekrar deneyin.');
    } else {
      setMessage('Şifre başarıyla güncellendi!');
      setTimeout(() => navigate('/auth'), 2000);
    }
    setLoading(false);
  };

  return (
    <Box maxWidth="400px" margin="auto" mt={8} p={5}>
      <form onSubmit={handleResetPassword}>
        <VStack spacing={4}>
          <FormControl>
            <FormLabel>8 Haneli Doğrulama Kodu</FormLabel>
            <Input
              type="text"
              inputMode="numeric"
              maxLength={8}
              value={resetCode}
              onChange={(e) => setResetCode(e.target.value.replace(/\D/g, ""))}
              autoComplete="one-time-code"
              required
            />
          </FormControl>
          <FormControl>
            <FormLabel>Yeni Şifre</FormLabel>
            <Input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
          </FormControl>
          <Button type="submit" colorScheme="blue" isLoading={loading}>Şifreyi Güncelle</Button>
          {message && <Text color={message.includes('başarıyla') || message.includes('successfully') ? 'green.500' : 'red.500'}>{message}</Text>}
        </VStack>
      </form>
    </Box>
  );
}
